<div class="multibanco" id="print-section">
  <div class="multibanco__heading mb-3">
    <img src="assets/images/icons8-multibanco-96-a.png" width="96" height="96"/>

    <h2 class="ml-2 mt-3 bold-600">€{{(details.amount / 100).toFixed(2)}}</h2>
    
    <div *ngIf="isToShowExpirationDate()" class="d-flex alignt-items-center mt-1">
      <span class="ml-2">{{ formatExpirationDate(details.expiresAt) }}</span>
      <div class="multibanco__expire-date--badget ml-2 bold-700">{{ remainingDaysForExpiration(details.expiresAt) }} days</div>
    </div>
  </div>

  <div class="multibanco__content mx-2">
    <div class="d-flex flex-column">
      <h6 class="d-flex bold-600 mt-2">Payment Details:</h6>
      
      <div class="multibanco__payment-details d-flex flex-column px-2 py-2 mt-2">
        <div class="d-flex justify-content-between">
          <span class="mb-1">Entity</span>
          <span class="multibanco__payment-details--reference">{{ details.entity }}</span>
          <i id="hide-on-print" class="multibanco__payment--copy-icon fas fa-clipboard" (click)="copyText(details.entity)"></i>
        </div>
  
        <div class="d-flex justify-content-between">
          <span>Reference</span>
          <span class="multibanco__payment-details--reference">{{ details.reference }}</span>
          <i id="hide-on-print" class="multibanco__payment--copy-icon fas fa-clipboard" (click)="copyText(details.reference)"></i>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column my-4">
      <h6 class="bold-600 mb-2">Payment instructions</h6>
  
      <p>1. In your online bank account or from an ATM, choose "Payment and other services".</p>
      <p>2. Click "Payments of services/shopping".</p>
      <p>3. Enter the entity number, reference number, and amount.</p>
      
      <div id="hide-on-print" class="d-flex justify-content-center align-items-center">
        <i class="multibanco__payment--copy-icon fas fa-clipboard" (click)="copyText(details.hostedVoucherUrl)"></i>
        <span class="ml-2 multibanco__payment--link">Copy link for sharing</span>
      </div>
    </div>
  </div>

  <div id="hide-on-print" class="mx-2">
    <button class="btn btn-primary my-2" type="button" (click)="printSection('print-section')">Print</button>
    <button class="btn done" (click)="done()">Done</button>
  </div>
</div>
